/**
 * SASS
 */
import '../scss/layout.scss';

/**
 * JavaScript
 */

import * as fslightbox from 'fslightbox';
import Kopernika_Map from './modules/map.js';
import Sliders from './modules/sliders.js';
import Investment from './modules/investment.js';
import AnchorPolyfill from './modules/anchor-polyfill.js';
import Marketing from './modules/marketing.js';

if(document.querySelector('[data-side-form-trigger]')) {
  handleSideForm();
}

document.querySelector('[data-premises-buildings-block]') ? handlePremisesBuildings() : '';

document.querySelector('[data-premise-360-view-block]') ? handlePremises360View() : '';

document.querySelector('[data-premise-block-links-block]') ? handlePremiseBlockLinks() : '';

document.querySelector('[data-floor-json]')
  ? window.addEventListener('load', () => {
      handleFloorVisualisation();
    })
  : '';

document.querySelector('[data-interactive-building-json]')
  ? window.addEventListener('load', () => {
      handleInteractiveBuilding();
    })
  : '';

// Development mode
if (fsLightbox && window.location.href.includes('//localhost:8000')) {
  //! Fix "Invalid source" fslighbox error while local development.
  fsLightbox.props.type = 'image';
}

function fixPlaceholders() {
  const invCart = JSON.parse(localStorage.getItem('inv_cart'));
  if (!invCart || !invCart.length) return;
  const fixedCart = invCart.map(el => {
    if (!el.plan_link.startsWith('//placehold.it')) return el;
    Object.assign(el, { plan_link: '//dummyimage.com/600x400.jpg' });
    return el;
  });
  localStorage.setItem('inv_cart', JSON.stringify(fixedCart));
}
fixPlaceholders();

new AnchorPolyfill(91);

new Kopernika_Map();

if (document.querySelector('#building_area')) {
  new Investment();
}

new Sliders();

if (document.querySelector('.form-control')) {
  new Marketing();
  const inputs = document.querySelectorAll('.form-control');
  inputs.forEach(input => {
    if (input.value.length > 0) input.parentNode.classList.add('active');
    input.addEventListener('focus', () => {
      input.parentNode.classList.add('active');
    });
    input.addEventListener('blur', () => {
      input.parentNode.classList.remove('active');
    });
    input.addEventListener('change', () => {
      if (input.checkValidity()) {
        input.parentNode.classList.remove('invalid');
        input.parentNode.classList.add('valid');
      } else {
        input.parentNode.classList.add('invalid');
        input.parentNode.classList.remove('valid');
      }
    });
  });
}

if (document.querySelector('.filterTrigger')) {
  const filterTriggers = document.querySelectorAll('.filterTrigger');
  const filters = document.querySelector('.flat-filters');
  const filterBtn = document.querySelector('.filter-btn');

  filterTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      filters.classList.toggle('active');
      filterBtn.classList.toggle('active');
    });
  });
}

if (document.querySelector('.hamburger')) {
  const hamburger = document.querySelector('.hamburger');
  const navbar = document.querySelector('ul.navbar');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('is-active');
    navbar.classList.toggle('active');
  });

  document.querySelectorAll('ul.navbar a').forEach(btn => {
    btn.onclick = () => {
      hamburger.classList.remove('is-active');
      navbar.classList.remove('active');
    };
  });
}

if (document.querySelector('.homenav')) {
  if (document.querySelector('.cart')) {
    document.querySelector('.cart').classList.add('hidden');
  }
  const homenav = document.querySelector('.homenav');
  let canchange = true;
  window.addEventListener('scroll', () => {
    let posY = window.pageYOffset;
    if (posY > 100) {
      homenav.classList.remove('homenav');
      if (document.querySelector('.cart')) {
        document.querySelector('.cart').classList.remove('hidden');
      }
    } else {
      homenav.classList.add('homenav');
      if (document.querySelector('.cart')) {
        document.querySelector('.cart').classList.add('hidden');
      }
    }
  });
}

if (document.querySelector('.lazy-img')) {
  const imgs = document.querySelectorAll('.lazy-img');
  imgs.forEach(drawImages);
}

function drawImages(target) {
  const obs = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const src = img.getAttribute('data-src');

        img.setAttribute('src', src);
        img.classList.add('fadeIn');

        observer.disconnect();
      }
    });
  });

  obs.observe(target);
}

if (document.querySelector('.phone-widget')) {
  const phoneWidget = document.querySelector('.phone-widget');
  const phoneWidgetInner = phoneWidget.querySelector('.phone-widget__inner');
  const controlBtn = phoneWidget.querySelector('.phone-widget__btn');

  controlBtn.addEventListener('click', () => {
    controlBtn.style.pointerEvents = 'none';
    setTimeout(() => {
      controlBtn.style.pointerEvents = 'all';
    }, 600);

    if (phoneWidget.classList.contains('is-open')) {
      phoneWidget.style.maxHeight = `0px`;
      phoneWidget.style.maxWidth = `0px`;
      phoneWidget.classList.remove('is-open');
    } else {
      phoneWidget.style.maxHeight = `${phoneWidgetInner.offsetHeight}px`;
      phoneWidget.style.maxWidth = `${phoneWidgetInner.offsetWidth}px`;
      phoneWidget.classList.add('is-open');
    }
  });
}

if (document.querySelector('.footer-form')) {
  document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.querySelector('.footer-form .contact-form');
    if (!contactForm) return;
    const firstLabel = contactForm.querySelector('.checkbox-frm');
    const allCheckboxes = contactForm.querySelectorAll('.checkbox-frm input');

    const selectAllAgreements = document.createElement('label');
    selectAllAgreements.classList.add('checkbox-frm');
    selectAllAgreements.innerHTML =
      '<input type="checkbox" id="selectAllAgreements"><span class="checkbox-mark"></span><span class="checkbox-content">Zaznacz wszystkie.</span>';

    contactForm.insertBefore(selectAllAgreements, firstLabel);

    selectAllAgreements.addEventListener('change', e => {
      if (e.target.checked) {
        allCheckboxes.forEach(checkbox => {
          checkbox.checked = true;
        });
      } else {
        allCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
      }
    });
  });
}
if (document.querySelector('.locals-text-content .content')) {
  const localsContentSneakPeak = document.querySelector('.locals-text-content .sneak-peak');
  const localsContentBtn = document.querySelector('.locals-text-content button');
  const localsContentFull = document.querySelector('.locals-text-content .full-content');
  localsContentBtn.addEventListener('click', function () {
    localsContentSneakPeak.style.display = 'none';
    localsContentFull.style.display = 'block';
    localsContentBtn.style.display = 'none';
  });
}

async function handleSideForm() {
  const { initializeSideForm } = await import('./modules/side-form');
  initializeSideForm();
}

async function handlePremisesBuildings() {
  const { premisesBuildings } = await import('./blocks/premises-building.js');
  premisesBuildings();
}

async function handlePremises360View() {
  const { premise360View } = await import('./blocks/premise-360-view.js');
  premise360View();
}

async function handlePremiseBlockLinks() {
  const { premiseBlockLinks } = await import('./blocks/premise-block-links.js');
  premiseBlockLinks();
}

async function handleFloorVisualisation() {
  const { FloorsVisualisation } = await import('./modules/visualisation/floors.js');
  new FloorsVisualisation();
}

async function handleInteractiveBuilding() {
  const { BuildingVisualisation } = await import('./modules/visualisation/building');
  new BuildingVisualisation();
}

window.addEventListener('DOMContentLoaded', calculateContainerWidth);
window.addEventListener('resize', calculateContainerWidth);

function calculateContainerWidth() {
  const target = document.querySelector('.container');
  if (!target) return;

  const { width } = target.getBoundingClientRect();
  document.querySelector(':root').style.setProperty('--container-width', `${width}px`);
}

function refreshScrollbarWidth() {
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
}

window.addEventListener('resize', refreshScrollbarWidth);
refreshScrollbarWidth();

if(document.querySelector('[data-premise-history]')) {
  (async () => {
    const { PriceHistory } = await import('./modules/PriceHistory');
    new PriceHistory();
  })();
}

if(document.querySelector('#modal-1')) {
  (async () => {
    const { Modal } = await import('./modules/Modal');
    Modal.getInstance();
  })();
}

if(document.querySelector('[data-tooltip]')) {
  (async () => {
    const { Tooltip } = await import('./modules/Tooltip');
    const tooltips = [];

    function generateTooltips() {
      const newTooltips = Array.from(document.querySelectorAll('[data-tooltip]')).map(trigger => {
        return new Tooltip(trigger);
      });

      tooltips.push(...newTooltips);
    }
    generateTooltips();

    document.addEventListener('premiseListRendered', () => {
      tooltips.forEach(tooltip => {
        tooltip.destroy();
      });

      tooltips.length = 0;

      generateTooltips();
    });

  })();
}